var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9755 5.89966L22.2255 2.14966C21.8593 1.78345 21.2661 1.78345 20.8999 2.14966L17.1499 5.89966C16.8816 6.16791 16.801 6.57074 16.9466 6.92139C17.0913 7.27158 17.4337 7.5 17.8127 7.5H19.6877V10.3125C19.6877 10.8302 20.107 11.25 20.6252 11.25H22.5002C23.0184 11.25 23.4377 10.8302 23.4377 10.3125V7.5H25.3127C25.6917 7.5 26.0341 7.27158 26.1788 6.92139C26.3244 6.57074 26.2438 6.16791 25.9755 5.89966Z",
    fill: "url(#paint0_linear_343_7158)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C14.3871 22.5 13.7861 22.3299 13.2641 22.0086L1.875 15V26.25C1.875 27.2855 2.71447 28.125 3.75 28.125H26.25C27.2855 28.125 28.125 27.2855 28.125 26.25V15L16.736 22.0086C16.2139 22.3299 15.613 22.5 15 22.5Z",
    fill: "url(#paint1_linear_343_7158)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07785 12.1875H26.9221C27.5865 12.1875 28.125 12.726 28.125 13.3904C28.125 13.8081 27.9083 14.1959 27.5526 14.4148L16.7359 21.0712C16.2139 21.3924 15.613 21.5625 15 21.5625C14.387 21.5625 13.7861 21.3924 13.2641 21.0712L2.44744 14.4148C2.0917 14.1959 1.875 13.8081 1.875 13.3904C1.875 12.726 2.41353 12.1875 3.07785 12.1875Z",
    fill: "url(#paint2_linear_343_7158)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 1.875C5.85297 1.875 3.75 3.97797 3.75 6.5625C3.75 9.14703 5.85297 11.25 8.4375 11.25C11.022 11.25 13.125 9.14703 13.125 6.5625C13.125 3.97797 11.022 1.875 8.4375 1.875ZM11.1832 4.46005L8.37067 9.14755C8.29651 9.27114 8.16925 9.354 8.02597 9.3714C8.00674 9.37368 7.98752 9.37506 7.96875 9.37506C7.84515 9.37506 7.72568 9.32608 7.63733 9.23773L5.76233 7.36273C5.57922 7.17962 5.57922 6.88299 5.76233 6.69989C5.94543 6.51678 6.24207 6.51678 6.42517 6.69989L7.87582 8.15054L10.3793 3.97757C10.5121 3.75601 10.8005 3.68322 11.0225 3.81689C11.2445 3.9501 11.3164 4.23803 11.1832 4.46005Z",
    fill: "url(#paint3_linear_343_7158)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_7158",
    x1: 21.5627,
    y1: 1.875,
    x2: 21.5627,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_7158",
    x1: 15,
    y1: 15,
    x2: 15,
    y2: 28.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_7158",
    x1: 15,
    y1: 12.1875,
    x2: 15,
    y2: 21.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_7158",
    x1: 8.4375,
    y1: 1.875,
    x2: 8.4375,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274A27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryRateIcon);
export default __webpack_public_path__ + "static/media/deliveryRateIcon.78db790cf419b14b2c8a47c10cf8eb2a.svg";
export { ForwardRef as ReactComponent };